/*
 * Thin fetch wrappers around the backend's unauthenticated marketing-site
 * endpoints (api/routes/public_marketing.py). These endpoints persist leads
 * to the DB and (for /agent-call) trigger a real outbound call server-side —
 * no API keys are ever exposed to this bundle.
 */

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "https://app.verasist.ai")
  .trim()
  .replace(/\/$/, "");

async function postJson(path, body) {
  const res = await fetch(`${API_BASE}/api/v1/public/marketing${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const detail = data?.detail;
    const message = Array.isArray(detail)
      ? detail.map((d) => d.msg).join(", ")
      : typeof detail === "string"
        ? detail
        : "Request failed";
    throw new Error(message);
  }

  return data;
}

/** Contact page / footer contact form. */
export const submitContactLead = ({ name, email, phone, company, message }) =>
  postJson("/contact", { name, email, phone, company, message });

/** Lead captured before starting a web voice call or chatbot session. */
export const submitAgentLead = ({ name, email, phone, source }) =>
  postJson("/lead", { name, email, phone, source });

/** Triggers a real outbound phone call to the lead via the backend proxy. */
export const triggerAgentCall = ({ name, email, phone, initialContext }) =>
  postJson("/agent-call", {
    name,
    email,
    phone,
    initial_context: initialContext || {},
  });
